import { useEffect, useState } from 'react'

import { SettingsLanguages } from '../../../../common/models'
import { getSettingsLanguages } from '../../../../core/services/festival-settings'

/**
 * Loads the current festival edition's configured languages (edition is resolved
 * from the `x-festival-name` header by the interceptor). Drives the per-locale
 * translation tabs. `defaultLocale` is the language flagged `isDefault` (falls
 * back to the first language, then `en-US`).
 */
export const useFestivalLanguages = () => {
  const [languages, setLanguages] = useState<SettingsLanguages[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      try {
        setLoading(true)
        const { data } = await getSettingsLanguages()
        if (!cancelled) setLanguages(data ?? [])
      } catch {
        if (!cancelled) setLanguages([])
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    load()
    return () => {
      cancelled = true
    }
  }, [])

  const defaultLocale =
    languages.find((l) => l.isDefault)?.locale ??
    languages[0]?.locale ??
    'en-US'

  return { languages, loading, defaultLocale }
}
